<!-- <h4 class="text-center">Select Sketch Variant and CAD Software</h4> -->
<h4 class="text-center">Select CAD Software</h4>

<!-- <div class="toggle-pill">
  <div
    class="pill-option text-center w-50"
    [class.active]="variantType === 'Non-CTS'"
    (click)="selectVariant('Non-CTS')">
    Sketch
  </div>
  <div
    class="pill-option text-center w-50"
    [class.active]="variantType === 'CTS'"
    (click)="selectVariant('CTS')">
    CTS Sketch
  </div>
</div> -->

<div class="card-container">
    <div class="cad-card p-2 p-sm-4" [class.selected]="selectedSoftware === productType.EplanSketch || selectedSoftware === productType.EplanCTSSketch" (click)="selectSoftware('Eplan')">
        <img src="assets/icons/eplan_new_icon.png" alt="Eplan Icon" class="cad-icon" />
        <div class="cad-name">Eplan</div>
    </div>
    <div class="cad-card p-2 p-sm-4" [class.selected]="selectedSoftware === productType.SEESketch || selectedSoftware === productType.SEECTSSketch" (click)="selectSoftware('See Electrical')">
        <img src="assets/icons/see_electrical_icon.png" alt="SEE Electrical Icon" class="cad-icon" />
        <div class="cad-name">SEE Electrical</div>
    </div>
    <div class="cad-card p-2 p-sm-4" [class.selected]="selectedSoftware === productType.PCSSketch || selectedSoftware === productType.PCSCTSSketch" (click)="selectSoftware('PC Schematic')">
        <img src="assets/icons/pc_schematic_icon.png" alt="PC Schematic Icon" class="cad-icon" />
        <div class="cad-name">PC Schematic</div>
    </div>
</div>

<div *ngIf="alreadySubscribedError" class="alert alert-danger text-center mt-3">
  You already have an active subscription for this app.
</div>

<div class="d-flex flex-row align-items-center mt-3 justify-content-between"> 
    <dx-button
        *ngIf="showBackButton"
        text="Back"
        icon="arrowleft"
        type="normal"
        (onClick)="this.backTriggered.emit();">
    </dx-button>
    <dx-button
        class="ml-auto"
        text="Next" 
        icon="arrowright"
        [rtlEnabled]="true"
        [disabled]="selectedSoftware === null || selectedSoftware === productType.Sketch"
        [elementAttr]="{class: 'next-button'}"
        type="default"
        (onClick)="proceed()">
    </dx-button>
</div>